import React from 'react';
import PropTypes from 'prop-types';
import { ClientArticle, ProfilePicture } from './styles';

const ClientTestimony = React.forwardRef((props, ref) => {
  return (
    <ClientArticle mode="client" ref={ref}>
      <div className="d-xs-none align-self-center">
        <ProfilePicture src={props.profilePicUrl} alt="" loading="lazy" />
      </div>
      <div className="pl-4 pr-4">
        <div className="header">
          <div className="profile pt-4 pb-4">
            <div className="name">{props.name}</div>
            <div>{props.position}</div>
            <div>{props.company}</div>
          </div>
        </div>
        <p>{props.description}</p>
      </div>
    </ClientArticle>
  );
});

ClientTestimony.displayName = 'ClientTestimony';

ClientTestimony.propTypes = {
  name: PropTypes.string,
  position: PropTypes.string,
  company: PropTypes.string,
  description: PropTypes.string,
  profilePicUrl: PropTypes.string,
  logoUrl: PropTypes.string,
};

export default ClientTestimony;
